export default "__VITE_ASSET__CghymMuk__"